module.exports = __webpack_public_path__ + "static/img/477.dcd95e0.png";